/** Guides blog Pro déjà en trafic Google — maillage homepage marketing. */
export const LANDING_TOP_BLOG_GUIDES = [
  {
    href: '/modele-facture-prestation-chien',
    label: 'Facture prestation chien (logiciel)',
    teaser: 'Mentions légales et numérotation : checklist logiciel, pas un PDF Word.',
  },
  {
    href: '/modele-contrat-garde-chien',
    label: 'Contrat de garde de chien',
    teaser: 'Clauses utiles (urgence, clés, annulation) avant d’accueillir un chien.',
  },
  {
    href: '/tarifs-educateur-canin-logiciel',
    label: 'Tarifs éducateur canin',
    teaser: 'Fixer un prix de séance et des forfaits dans le logiciel, sans grille inventée.',
  },
  {
    href: '/blog/fiche-client-chien-infos-obligatoires',
    label: 'Fiche client chien : infos à collecter',
    teaser: 'Ce qu’il faut demander dès l’arrivée d’un nouveau client et de son chien.',
  },
  {
    href: '/blog/acompte-réservation-chien-quand-demander',
    label: 'Quand demander un acompte ?',
    teaser: 'Repères pour sécuriser une réservation sans froisser le propriétaire.',
  },
  {
    href: '/blog/contrat-garde-chien-pension-clauses-essentielles',
    label: 'Contrat de garde / pension',
    teaser: 'Clauses essentielles avant d’accueillir un chien en garde ou pension.',
  },
  {
    href: '/blog/facture-auto-entrepreneur-prestation-chien-modèle',
    label: 'Modèle de facture prestation chien',
    teaser: 'Structure et mentions utiles pour facturer une prestation canine.',
  },
  {
    href: '/blog/tarif-toiletteur-canin-fourchettes-2026',
    label: 'Tarifs toiletteur canin 2026',
    teaser: 'Fourchettes pour positionner tes prestations de toilettage.',
  },
  {
    href: '/blog/tarifs-educateur-canin-comment-fixer-prix-seance',
    label: 'Fixer le prix d’une séance d’éducation',
    teaser: 'Comment tarifer une séance sans sous-estimer ton temps.',
  },
] as const;
